var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_vm._v("Loading...")]) : [_c('Status', {
    staticClass: "s-mb-6 s-text-gray",
    attrs: {
      "icon": "check",
      "message": "已為您取消訂單"
    }
  }), _c('div', {
    staticClass: "s-space-y-8 s-pb-8 s-mb-5 s-border-b s-border-gray-lighter"
  }, [_c('DescriptionList', {
    attrs: {
      "title": "商品名稱"
    }
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('DescriptionList', {
    attrs: {
      "title": "款式"
    }
  }, [_vm._v(_vm._s(_vm.spec.sku_name))]), _c('DescriptionList', {
    attrs: {
      "title": "團購 ID"
    }
  }, [_vm._v(_vm._s(_vm.groupBuying.groupbuying_number))])], 1), _c('router-link', {
    staticClass: "s-btn s-btn-secondary",
    attrs: {
      "to": {
        name: 'LiffGroupBuyingShow',
        params: {
          id: _vm.groupBuying.id
        }
      }
    }
  }, [_vm._v(" 重新下單 ")])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }